<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>小程序用户</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="content">
      <el-form inline :model="query" label-position="right" label-width="60px" size="small" class="query-form"
        @submit.native.prevent="getList()">
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="编号/昵称/姓名/手机"></el-input>
        </el-form-item>
        <el-form-item label="等级">
          <el-select v-model="query.levelId" clearable placeholder="全部" style="width:120px" @change="selClick">
            <el-option v-for="item in levelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick()">查询</el-button>
        </el-form-item>
      </el-form>

      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>小程序用户</span>
        </div>

        <el-table v-loading="loading" :data="tableData" ref="tableData" border stripe style="width: 100%"
          @sort-change="sortChange">
          <!-- <el-table-column prop="id" label="用户ID" width="80"></el-table-column> -->
          <el-table-column prop="code" label="编号" width="120"></el-table-column>
          <el-table-column label="头像" width="100">
            <template slot-scope="scope">
              <img :src="scope.row.photo" :style="{ width: '50px', borderRadius: '50%' }" />
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="昵称" min-width="120"></el-table-column>
          <el-table-column prop="realName" label="真实姓名" width="100"></el-table-column>
          <el-table-column prop="mobile" label="手机号" width="120"></el-table-column>
          <el-table-column label="会员等级" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.levelID == 2" type="warning">{{ scope.row.levelName }}</el-tag>
              <el-tag v-else type="info">{{ scope.row.levelName }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="CRM学生" min-width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.crmStudentID">{{ scope.row.crmStudentName || ('#' + scope.row.crmStudentID)
                }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="adviserName" label="顾问" width="100"></el-table-column>
          <el-table-column prop="documentName" label="文案" width="100"></el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isLock" type="danger">锁定</el-tag>
              <el-tag v-else type="success">正常</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="lastLoginTime" label="最后登录" width="160" class-name="hidden-s"></el-table-column> -->
          <el-table-column prop="createTime" label="注册时间" width="160" class-name="hidden-s"></el-table-column>

          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button type="primary" size="mini" plain icon="el-icon-edit"
                    @click="editClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <div class="block" style="margin-top: 20px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage4" :page-size="pageSize" :page-sizes="[10, 20, 30, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <el-dialog :title="form.id > 0 ? '编辑用户' : '用户详情'" :visible.sync="dialogVisible" width="640px"
      :close-on-click-modal="false" @opened="dialogOpened()">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm('form')">
        <!-- <el-form-item label="编号">
          <el-input v-model="form.code" disabled></el-input>
        </el-form-item> -->
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item prop="realName" label="真实姓名" :rules="[{ required: true, message: '不能为空' }]">
              <el-input v-model="form.realName" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="sex" label="性别">
              <el-switch v-model="form.sex" :active-value="true" :inactive-value="false"></el-switch>
              <el-tag v-if="form.sex" type="success" style="margin-left:8px">男</el-tag>
              <el-tag v-else type="warning" style="margin-left:8px">女</el-tag>
            </el-form-item>
          </el-col>
        </el-row>


        <el-form-item prop="nickName" label="昵称">
          <el-input v-model="form.nickName" placeholder="微信昵称"></el-input>
        </el-form-item>

        <el-form-item prop="mobile" label="手机号">
          <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>

        <el-form-item label="身份证号">
          <el-input v-model="form.idCard" placeholder="请输入身份证号"></el-input>
        </el-form-item>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="会员等级">
              <el-select v-model="form.levelID" style="width: 100%">
                <el-option v-for="item in levelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="CRM学生">
              <el-select v-model="form.crmStudentID" filterable remote clearable reserve-keyword
                placeholder="姓名/手机/微信搜索" :remote-method="searchCrmStudent" :loading="stuLoading" style="width: 100%"
                @change="onCrmStudentChange">
                <el-option v-for="item in crmStudentList" :key="item.id" :label="item.label"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="顾问老师">
              <el-input :value="form.adviserName || '—'" disabled></el-input>
              <div class="form-tip" style="margin-left:0;margin-top:4px">来自 CRM 学生资料，不可在此修改</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="文案老师">
              <el-input :value="form.documentName || '—'" disabled></el-input>
              <div class="form-tip" style="margin-left:0;margin-top:4px">来自 CRM 学生资料，不可在此修改</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="锁定账号">
          <el-switch v-model="form.isLock"></el-switch>
          <span class="form-tip">锁定后用户将无法登录小程序</span>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: { key: "", levelId: null },
      form: {},
      loading: false,
      dialogVisible: false,
      submiting: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1,
      levelList: [],
      crmStudentList: [],
      stuLoading: false
    };
  },
  mounted() {
    $.get(url.getMiniManage("GetSelList_MemberLevel"), {}, res => {
      this.levelList = res;
    });
    this.getList();
  },
  methods: {
    api(action) {
      return url.getMiniManage(action);
    },
    searchCrmStudent(key) {
      var _this = this;
      if (!key) {
        _this.crmStudentList = [];
        return;
      }
      _this.stuLoading = true;
      $.get(_this.api("Search_CrmStudent"), { key: key }, res => {
        _this.stuLoading = false;
        _this.crmStudentList = res || [];
      });
    },
    ensureCrmStudentOption(row) {
      if (!row || !row.crmStudentID) return;
      var exists = this.crmStudentList.some(q => q.id === row.crmStudentID);
      if (!exists) {
        var name = row.crmStudentName || row.realName || "学生";
        this.crmStudentList = [{
          id: row.crmStudentID,
          label: name + " #" + row.crmStudentID,
          isVip: row.levelID == 2,
          realName: row.crmStudentName || row.realName,
          mobile: row.mobile,
          adviserID: row.adviserID,
          adviserName: row.adviserName,
          documentID: row.documentID,
          documentName: row.documentName
        }].concat(this.crmStudentList);
      }
    },
    onCrmStudentChange(id) {
      if (!id) {
        this.form.crmStudentID = null;
        return;
      }
      var item = this.crmStudentList.find(q => q.id === id);
      if (!item) return;
      this.form.crmStudentID = item.id;
      if (item.isVip) this.form.levelID = 2;
      if (item.realName && !this.form.realName) this.form.realName = item.realName;
      if (item.mobile && !this.form.mobile) this.form.mobile = item.mobile;
      // 顾问/文案只展示 CRM 数据
      if (item.adviserName != null) this.form.adviserName = item.adviserName;
      if (item.adviserID != null) this.form.adviserID = item.adviserID;
      if (item.documentName != null) this.form.documentName = item.documentName;
      if (item.documentID != null) this.form.documentID = item.documentID;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    sortChange(sortColumn) {
      this.query.sort = sortColumn.prop;
      this.query.order = sortColumn.order;
      this.getList();
    },
    getList() {
      var _this = this;
      _this.loading = true;
      var params = Object.assign({}, _this.query);
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      if (!params.levelId) params.levelId = 0;
      $.get(_this.api("GetList_WxUser"), params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    selClick() {
      this.currentPage4 = 1;
      this.getList();
    },
    editClick(row) {
      this.form = Object.assign({}, row);
      if (this.form.sex === null || this.form.sex === undefined) {
        this.form.sex = false;
      }
      this.ensureCrmStudentOption(this.form);
      this.dialogVisible = true;
    },
    dialogOpened() { },
    submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(valid => {
        if (!valid) return false;
        _this.submiting = true;
        $.post(_this.api("Save_WxUser"), _this.form, res => {
          _this.submiting = false;
          if (res.status) {
            _this.dialogVisible = false;
            _this.getList();
            _this.$message({ type: "success", message: res.msg });
          } else {
            _this.$message({ type: "error", message: res.msg });
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}

.form-tip {
  margin-left: 10px;
  color: #999;
  font-size: 12px;
}
</style>
